/**
 * Centralized theme system barrel export.
 *
 * Usage:
 * ```tsx
 * import { ThemeProvider, useTheme } from "./src/theme";
 * // or, once wired into the hooks barrel:
 * import { useTheme } from "./src/hooks";
 * ```
 */
export { ThemeProvider } from "./ThemeContext";
export { useTheme } from "./useTheme";
export type { ThemeMode, ResolvedTheme, Theme, ThemeColors } from "./types";
